import i18n from 'i18n';
import { LIST_MAX_SIZE } from 'config';

function cutAndAddViewAllItem(items, listId) {
  return items.slice(0, LIST_MAX_SIZE - 1).concat([
    {
      type: 'VIEW_ALL',
      title: i18n.t('common.watchAllButton'),
      titles: {
        UA: i18n.t('common.watchAllButton'),
        EN: i18n.t('common.watchAllButton'),
      },
      listId,
    },
  ]);
}

export default cutAndAddViewAllItem;
